<a [routerLink]="href">
  <div class="img-container" [ngClass]="{ 'disabled-card-container': !cardAvailable }">
    <img
      [ngClass]="{ 'img-disabled': !cardAvailable }"
      [src]="image"
      [alt]="brand"
      [attr.loading]="priorityImage ? 'eager' : 'lazy'"
    />
    <div
      [ngClass]="{ 'disabled-text': !cardAvailable }"
      [ngStyle]="{ display: cardAvailable ? 'none' : 'block' }"
    >
      <p><strong>Temporarily unavailable</strong></p>
      <p ng-bind-html="text | unsafeLinky:'_blank'">Will be back soon</p>
    </div>
  </div>
  <div class="title">
    <p class="card-title-text">
      {{ brand }}
    </p>
    <ng-container *ngIf="hasAvailableTag()">
      <p *ngIf="getCashbackText()" class="cash-back-tag">
        {{ getCashbackText() }}
      </p>
      <p *ngIf="getPlainTagText()" class="cash-back-tag">
        {{ getPlainTagText() }}
      </p>
    </ng-container>
  </div>
</a>
